import { Tooltip } from '@heroui/react';
import { ChevronDown, ChevronUp, Eye, EyeOff, Lock, Trash2, Unlock } from 'lucide-react';
import React, { FC } from 'react';

import { useAdsGeneratorStore } from '../../../model/store';
import { PanelSection } from '../../common';
import { EmptyPanelHint, LayerName, LayerRow } from '../Editor.styled';

const ICON_BUTTON = 'flex h-6 w-6 items-center justify-center rounded text-gray-500 hover:bg-gray-100 hover:text-gray-900';

/** Lista warstw od wierzchu do spodu, bo tak użytkownik widzi kreację. */
export const LayersPanel: FC = () => {
  const scene = useAdsGeneratorStore((state) => state.scene);
  const selectedIds = useAdsGeneratorStore((state) => state.selectedIds);
  const select = useAdsGeneratorStore((state) => state.select);
  const updateElement = useAdsGeneratorStore((state) => state.updateElement);
  const removeElement = useAdsGeneratorStore((state) => state.removeElement);
  const moveLayer = useAdsGeneratorStore((state) => state.moveLayer);

  if (!scene) return null;

  if (scene.elements.length === 0) {
    return (
      <PanelSection title="Warstwy">
        <EmptyPanelHint>Plansza jest pusta. Dodaj tekst, kształt albo zdjęcie.</EmptyPanelHint>
      </PanelSection>
    );
  }

  return (
    <PanelSection title="Warstwy">
      <div className="flex flex-col gap-1">
        {[...scene.elements].reverse().map((element) => (
          <LayerRow key={element.id} $active={selectedIds.includes(element.id)}>
            <button
              type="button"
              className={ICON_BUTTON}
              title={element.hidden ? 'Pokaż' : 'Ukryj'}
              onClick={() => updateElement(element.id, { hidden: !element.hidden })}
            >
              {element.hidden ? <EyeOff size={14} /> : <Eye size={14} />}
            </button>
            <LayerName type="button" onClick={() => select(element.id)}>
              {element.type === 'text' ? element.text.slice(0, 28) || element.name : element.name}
            </LayerName>
            <Tooltip content="Wyżej" size="sm">
              <button type="button" className={ICON_BUTTON} onClick={() => moveLayer(element.id, 'up')}>
                <ChevronUp size={14} />
              </button>
            </Tooltip>
            <Tooltip content="Niżej" size="sm">
              <button type="button" className={ICON_BUTTON} onClick={() => moveLayer(element.id, 'down')}>
                <ChevronDown size={14} />
              </button>
            </Tooltip>
            <button
              type="button"
              className={ICON_BUTTON}
              title={element.locked ? 'Odblokuj' : 'Zablokuj'}
              onClick={() => updateElement(element.id, { locked: !element.locked })}
            >
              {element.locked ? <Lock size={14} /> : <Unlock size={14} />}
            </button>
            <button
              type="button"
              className={ICON_BUTTON}
              title="Usuń"
              onClick={() => removeElement(element.id)}
            >
              <Trash2 size={14} />
            </button>
          </LayerRow>
        ))}
      </div>
    </PanelSection>
  );
};
